import * as React from "react";

export const assistingInstruction = <>
    For assistance with condo list option please send an email to{" "}
    <a
        href={"mailto:maillist@elliman.com"}
        xd-qa-type="link" 
        xd-qa-name="mail to"
    >
        maillist@elliman.com
    </a>
</>;